import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'ClusterPickingreport',
	components: {
		BasicSelect,
		Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		download,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// totalRows:0,
			// currentPage: 0,
			selectedmerchant: {
				value: '',
				text: ''
			},
			merchantList: [],
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			isLoadingforxls: false,
			searchfor: '',
			searchchannel: '',
			searchstatus: '',
			totalPage: 0,
			totalforclusteridPage: 0,
			totalRows: 0,
			totalClusterRows: 0,
			checkflag: false,
			currentPage: 1,
			currentPageOFcluster: 1,
			pageLimit: 10,
			clusterid: '',
			listClusterPickCollapseData: [],
			listClusterPickCollapseDatacsv: [],
			listStockReportFinalData: [],
			csvFields: [],
			oneshipdetails: [],
			opened: [],
			limitExeed: false,
			recordLimit: 0,
			// pageno: 0,
			// totalPage: 0,
			SearchOrderID: '',
			SearchClusterID: '',
			isLoading: false,
			formattedDate: '',
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			ClientErr: '',
			WarehouseErr: '',
			SearchforErr: '',
			SearchOrderidErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			DateError: '',
			user_type: '',
			userid: '',
			channellist: [],
			contentVisible: false,
			ClusterfromDateFlt: '',
			SearchOrderidErrflag: false,
			ClustertoDateFlt: '',
			searchClusterID: '',
			OrderIDfromDateFlt: '',
			Serchorderid: '',
			OrderIDtoDateFlt: '',
			toCheckShowRowIndex: '',
			searchforFlt: '',
			listMerchantData: [],
			MerchantList: [],
			merchantid: "",
			merchant: "",
			clustercompleteddate: "",
			orderstatuslist: [{
				'status': 'all'
			}, {
				'status': 'inprogress'
			}, {
				'status': 'completed'
			}, {
				'status': 'pending'
			}],
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{
				value: '',
				text: this.$t('common.selectMerchantPlaceHolder')
			}],
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY hh:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.userid = userdetail.userid;
		this.reportname = this.$t('editedjson.ClusterPickingreport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getClusterReportData();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()

	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {
			// select option from parent component
			this.item = item
			this.merchant = item.value;

		},
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchant = data.value;
		},
		//open new form(popup)
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		isNumeric: function (n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getClusterReportDataForXls(3);
			}

		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.merchant = "";
		// 		this.getMerchantList();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getWarehouseList();
		// 			this.getSalesChannels();

		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.getSalesChannels();

		// 			// this.getClusterReportData();
		// 		}
		// 	}
		// 	this.orderid = '';
		// 	this.clusterid = '';
		// 	this.contentVisible = false;
		// 	this.listClusterPickCollapseData = [];
		// 	this.pageno = this.totalPage = 0;

		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getClusterReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (localStorage.getItem("selectedClient") == '') {
				this.WarehouseErr = this.$t('common.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: localStorage.getItem("selectedClient")
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getClusterReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.totalforclusteridPage = 0
			this.searchFlag = true;
			this.getClusterReportData(2);
		},
		//to get client list
		getClusterReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (this.searchClusterID && this.searchClusterID != null && this.searchClusterID != "") {
				if (isNaN(this.searchClusterID)) {
					this.$alertify.error(this.$t('clusterPackingReport.clusterIDErr'))
					document.getElementById('searchClusterID').value = ''
					return false;
				}
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listClusterPickCollapseData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr =  this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listClusterPickCollapseData = [];
				return false;
			}
			// if (this.searchforFlt == '' || this.searchforFlt == '') {
			// 	this.SearchforErr = "Search For is required";
			// 	this.pageNo = this.totalPage = 0;
			// 	this.listClusterPickCollapseData = [];
			// 	return false;
			// }
			var fromdate = '';
			var todate = '';
			if (this.ClusterfromDateFlt != null && this.ClusterfromDateFlt != "") {
				var fromdatecluster = this.dateFormat(this.ClusterfromDateFlt) + " 00:00:00";
			}
			if (this.ClustertoDateFlt != null && this.ClustertoDateFlt != "") {
				var todatecluster = this.dateFormat(this.ClustertoDateFlt) + " 23:59:59";
			}
			if (this.OrderIDfromDateFlt != null && this.OrderIDfromDateFlt != "") {
				var fromdateorderid = this.dateFormat(this.OrderIDfromDateFlt) + " 00:00:00";
			}
			if (this.OrderIDtoDateFlt != null && this.OrderIDtoDateFlt != "") {
				var todateorderid = this.dateFormat(this.OrderIDtoDateFlt) + " 23:59:59";
			}
			if (this.searchforFlt == 'order') {
				this.checkflag = true;
			}
			// if (this.searchstatus == 'all') {
			// 	this.searchstatus = "";
			// }

			this.isLoading = true;

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.Serchorderid,
				clusterid: this.searchClusterID,
				saleschannel: this.searchchannel,
				clusterstatus: this.searchstatus,
				outputfor: 'cluster',
				fromdatecluster: fromdatecluster,
				todatecluster: todatecluster,
				fromdateorderid: fromdateorderid,
				todateorderid: todateorderid,
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				csvdata: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvdata'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getclusterpickingReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.ErrorCode == 0 && result.data.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listClusterPickCollapseDataCsv = [];
							this.csvFields = {
								'clusterid':this.$t('clusterPackingReport.table.columns.clusterId'),
								'orderid': this.$t('cancelPutawayPendingReport.orderId'),
								'totalsku':this.$t('inwardList.inward.totalSKU'),
								'totalqty':this.$t('orders.totalQTY'),
								'pickqty': this.$t('pickingReport.table.columns.pickQty'),
								'pendingqty': this.$t('clusterPackingReport.table.columns.pendingQty'),
								'orderstatus': this.$t('clusterPackingReport.table.columns.orderStatus'),
								'pickername': this.$t('clusterPackingReport.table.columns.pickerName'),
								'orderdate': this.$t('clusterPackingReport.table.columns.orderDate'),
								'clustercompleteddate': this.$t('editedjson.clustercompleteddate'),
								'clusterdate': this.$t('clusterPackingReport.table.columns.clusterDate'),
								'nfqty': this.$t('pickingReport.table.columns.nfQty'),
								'merchantname':  this.$t('pickingReport.table.columns.merchantName')
							};

							var dateFilter = [];
							var skipFilter = [];
							if (this.checkflag == true) {
								this.listClusterPickCollapseDataCsv = result.data.data.data.data;

							} else {
								this.listClusterPickCollapseDataCsv = result.data.data.data;

							}
							csvHelper.data.jsonToCSV(this.$t('editedjson.ClusterPickingreport'), this.listClusterPickCollapseDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('clusterReportDayWise', this.listClusterPickCollapseDataCsv, this.csvFields, dateFilder, skipFilter);
						} else {
							if (result.data.data.ErrorCode == 0) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.data.msg);
							}
						}



					} else {

						if (result.data.data.ErrorCode == -1 || result.data.data.ErrorCode == 1) {
							this.resultCount = 0
							this.totalRows = 0
							this.listClusterPickCollapseData = [];
						} else {
							this.listClusterPickCollapseData = result.data.data.data.data;
							// this.listClusterPickCollapseData.push({
							//   contentVisible: true
							// });

							this.totalRows = result.data.data.data.totalCount
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.data.data.totalCount
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		getClusterReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			if (this.searchClusterID && this.searchClusterID != null && this.searchClusterID != "") {
				if (isNaN(this.searchClusterID)) {
					this.$alertify.error(this.$t('clusterPackingReport.clusterIDErr'))
					document.getElementById('searchClusterID').value = ''
					return false;
				}
			}
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listClusterPickCollapseData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listClusterPickCollapseData = [];
				return false;
			}
			// if (this.searchforFlt == '' || this.searchforFlt == '') {
			// 	this.SearchforErr = "Search For is required";
			// 	this.pageNo = this.totalPage = 0;
			// 	this.listClusterPickCollapseData = [];
			// 	return false;
			// }
			var fromdate = '';
			var todate = '';
			if (this.ClusterfromDateFlt != null && this.ClusterfromDateFlt != "") {
				var fromdatecluster = this.dateFormat(this.ClusterfromDateFlt) + " 00:00:00";
			}
			if (this.ClustertoDateFlt != null && this.ClustertoDateFlt != "") {
				var todatecluster = this.dateFormat(this.ClustertoDateFlt) + " 23:59:59";
			}
			if (this.OrderIDfromDateFlt != null && this.OrderIDfromDateFlt != "") {
				var fromdateorderid = this.dateFormat(this.OrderIDfromDateFlt) + " 00:00:00";
			}
			if (this.OrderIDtoDateFlt != null && this.OrderIDtoDateFlt != "") {
				var todateorderid = this.dateFormat(this.OrderIDtoDateFlt) + " 23:59:59";
			}
			if (this.searchforFlt == 'order') {
				this.checkflag = true;
			}
			// if (this.searchstatus == 'all') {
			// 	this.searchstatus = "";
			// }



			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.Serchorderid,
				clusterid: this.searchClusterID,
				saleschannel: this.searchchannel,
				clusterstatus: this.searchstatus,
				outputfor: 'cluster',
				fromdatecluster: fromdatecluster,
				todatecluster: todatecluster,
				fromdateorderid: fromdateorderid,
				todateorderid: todateorderid,
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				csvdata: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getclusterpickingReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.ErrorCode == 0 && result.data.data.data.length > 0) {
							this.listStockReportDataforxls = [];
							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.clusterId')] = 'clusterid',
							this.csvFieldsForXls[this.$t('cancelPutawayPendingReport.orderId')] = 'orderid',
							this.csvFieldsForXls[this.$t('inwardList.inward.totalSKU')] =  'totalsku',
							this.csvFieldsForXls[this.$t('orders.totalQTY')] =  'totalqty',
							this.csvFieldsForXls[this.$t('pickingReport.table.columns.pickQty')] =  'pickqty',
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.pendingQty')] =  'pendingqty',
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.pickerName')] =  'pickername',
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.orderDate')] =  'orderdate',
							this.csvFieldsForXls[this.$t('editedjson.clustercompleteddate')] =  'clustercompleteddate',
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.clusterDate')] =  'clusterdate',
							this.csvFieldsForXls[this.$t('pickingReport.table.columns.nfQty')] =  'nfqty',
							this.csvFieldsForXls[this.$t('clusterPackingReport.table.columns.orderStatus')] =  'orderstatus',
							this.csvFieldsForXls[this.$t('pickingReport.table.columns.merchantName')] = 'merchantname',
						

							this.listStockReportDataforxls = result.data.data.data;
						} else {
							console.log(result.data.data.status);
							if (result.data.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.data.data.msg);
							}
						}


					}


				}, error => {
					console.error(error)
				})
		},
		getPaginationData(currentPage) {
			this.pageno = (currentPage - 1) * 10
			this.getClusterReportData();
		},
		getPaginationDataForCluster(currentPageOFcluster) {
			this.pageno = (currentPageOFcluster - 1) * 10
			this.getClusterReportforclusteridData();
		},
		getClusterReportforclusteridData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.ClientErr = '';
			this.oneshipdetails = [];
			this.offset = 0;
			this.limit = 10;

			var fromdate = '';
			var todate = '';
			if (this.ClusterfromDateFlt != null && this.ClusterfromDateFlt != "") {
				var fromdatecluster = this.dateFormat(this.ClusterfromDateFlt) + " 00:00:00";
			}
			if (this.ClustertoDateFlt != null && this.ClustertoDateFlt != "") {
				var todatecluster = this.dateFormat(this.ClustertoDateFlt) + " 23:59:59";
			}
			if (this.OrderIDfromDateFlt != null && this.OrderIDfromDateFlt != "") {
				var fromdateorderid = this.dateFormat(this.OrderIDfromDateFlt) + " 00:00:00";
			}
			if (this.OrderIDtoDateFlt != null && this.OrderIDtoDateFlt != "") {
				var todateorderid = this.dateFormat(this.OrderIDtoDateFlt) + " 23:59:59";
			}
			this.isLoading = true;

			if (csvCheck == 2)
				this.pageno = 0;
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.Serchorderid,
				saleschannel: this.searchchannel,
				clusterstatus: this.searchstatus,
				outputfor: 'order',
				fromdatecluster: fromdatecluster,
				todatecluster: todatecluster,
				fromdateorderid: fromdateorderid,
				todateorderid: todateorderid,
				clusterid: this.clusterid,
				offset: 0,
				limit: 100,
				csvdata: csvCheck,
				userid: this.userid,
				merchantid: this.merchant,
			})

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getclusterpickingReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.oneshipdetails = result.data.data.data.data
					this.contentVisible = true;
					if (result.data.errorCode == -1 || result.data.errorCode == 1) {
						this.resultCount = 0
						this.totalClusterRows = 0
					} else {
						this.totalClusterRows = result.data.data.data.totalCount
						this.resultCount = result.data.data.data.totalCount
						if (this.totalClusterRows < 10) {
							this.totalforclusteridPage = 1
						} else {
							this.totalforclusteridPage = Math.ceil(this.totalClusterRows / 10)
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
				})
		},
		// onchangerow(){
		//
		// },
		changedate() {
			this.ClusterfromDateFlt = '';
			this.ClustertoDateFlt = '';
			this.searchClusterID = '';
			this.OrderIDfromDateFlt = '';
			this.Serchorderid = '';
			this.OrderIDtoDateFlt = '';
			this.checkflag = false;
			this.contentVisible = false;
			this.clusterid = '';
			this.orderid = '';
		},
		showRow(data) {
			this.contentVisible = false;
			this.totalforclusteridPage = 0
			this.currentPageOFcluster = 1;
			this.searchfor = 'order';
			this.clusterid = data.clusterid;
			this.orderid = data.orderid;

			this.getClusterReportforclusteridData()
			this.toCheckShowRowIndex = Number(this.listClusterPickCollapseData.indexOf(data))
			for (var i = 0; i < this.listClusterPickCollapseData.length; i++) {
				if (this.listClusterPickCollapseData[i].contentVisible == true && i != this.toCheckShowRowIndex) {
					this.listClusterPickCollapseData[i].contentVisible = false
				}
			}
			data.contentVisible = !data.contentVisible;
			const index = this.opened.indexOf(data.tripid);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = []
				this.opened.push(data.tripid)
			}
		},
		onPageChange(page) {
			this.currentPage = page;
			this.orderid = '';
			this.clusterid = '';
			this.contentVisible = false;

			this.getClusterReportData()

		},
		onPageForClusterChange(page) {
			this.currentPageOFcluster = page;
			this.getClusterReportforclusteridData()
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD ');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		//to reset search form
		validateorderid() {
			if (this.searchClusterID && !this.isNumeric(this.searchClusterID)) {
				this.SearchOrderidErr = this.$t('clusterPackingReport.clusterIDErr');
				return false;
			} else {
				this.SearchOrderidErr = '';

			}
		},
		resetSearchForm() {

			this.item = {
				value: '',
				text: ''
			};
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.selectMerchantPlaceHolder')
			// }];
			this.SearchOrderidErrflag = false;
			this.searchfor = '';
			this.searchchannel = '';
			this.SearchOrderID = '';
			this.SearchClusterID = '';
			this.ClusterfromDateFlt = '';
			this.ClustertoDateFlt = '';
			this.OrderIDfromDateFlt = '';
			this.Serchorderid = '';
			this.OrderIDtoDateFlt = '';
			this.searchforFlt = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.orderid = '';
			this.clusterid = '';
			this.searchstatus = '';
			this.listClusterPickCollapseData = [];
			this.oneshipdetails = [];
			this.contentVisible = false;
			this.searchFlag = false;
			this.merchantList = []
			this.selectedmerchant = {}
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem("userToken");
			var myStr = userToken.replace(/"/g, "");
			this.input = {
				clientid: localStorage.getItem("selectedClient"),
			};
			axios({
				method: "POST",
				url: apiUrl.api_url + "merchantList",
				data: this.input,
				headers: {
					Authorization: "Bearer " + myStr,
				},
			}).then(
				(result) => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{
								value: '',
								text: this.$t('common.selectMerchantPlaceHolder')
							}]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})
					}
				},
				(error) => {
					console.error(error);
				}
			);
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/reports/clusterpickcollapse/clusterpickcollapse.component.js